<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 85 85" width="100px" height="100px">
    <path fill="#D0E5A8" d="M42.45,80.07c-20.67,0-37.48-16.82-37.48-37.48C4.97,21.92,21.79,5.1,42.45,5.1s37.48,16.81,37.48,37.48
            C79.94,63.25,63.12,80.07,42.45,80.07z M42.45,7.89c-19.13,0-34.7,15.57-34.7,34.7c0,19.13,15.56,34.7,34.7,34.7
      s34.7-15.56,34.7-34.7C77.15,23.46,61.59,7.89,42.45,7.89z"/>
    <path fill="#AEE852" d="M35.81,58.67c-0.52,0-1.01-0.21-1.38-0.57L21.37,45.04c-0.76-0.76-0.76-2,0-2.76c0.76-0.76,2-0.76,2.76,0
      l11.68,11.68l25.52-25.53c0.76-0.76,2-0.76,2.76,0c0.76,0.76,0.76,2,0,2.76l-26.9,26.9C36.82,58.46,36.33,58.67,35.81,58.67z"/>
  </svg>
</template>
